import React, {useEffect, useRef, useState} from "react";
import styles from "./Request.module.css"
import {
    setErrorMessage,
    useGlobalDispatch,
    useGlobalState
} from "../../context/GlobalState";
import MaxModal from "../../MaxModal/MaxModal";
import NewRequest from "./NewRequest";
import {
    deleteRequest,
    getErrors,
    getFullRequest,
    getInvoiceList,
    getResult,
    getSteps,
    getTempFileLinks
} from "../../services/api";
import {FaXmark} from "react-icons/fa6";
import ReactJson from "react-json-view";
import {IoReload} from "react-icons/io5";
import ResultCard from "./ResultCard";
import ResultCardForInvoice from "./ResultCardForInvoice";
import {LuFileSearch} from "react-icons/lu";
import {BsClipboardCheck} from "react-icons/bs";
import {TbDatabaseSearch} from "react-icons/tb";
import {RxActivityLog} from "react-icons/rx";
import {FiAlertTriangle} from "react-icons/fi";
import {MdDelete} from "react-icons/md";

const getLastNDaysDate = (N) => {
    const today = new Date();
    const lastNDays = new Date(today.setDate(today.getDate() - N));
    return lastNDays.toISOString().split('T')[0]; // Format as YYYY-MM-DD
};
const getCurrentDate = (N) => {
    return new Date().toISOString().split('T')[0]; // Format as YYYY-MM-DD
};

const toDollarCost = (v) => {
    if (v == null) return '';
    return 'U$'+ v.toFixed(4);
}

function simplifyDateFormat2(input) {
    if (!input) return input;
    if (typeof input !== 'string') {
        return input;
    }
    const [date, timeWithMilliseconds] = input.split('T');
    const [year, month, day] = date.split('-');
    const [time] = timeWithMilliseconds.split('.');
    const [hour, minute] = time.split(':');

    return `${month}/${day} ${hour}:${minute}`;
}

const Request = () => {
    const dispatch = useGlobalDispatch();
    const {theme, layout, profile, loading} = useGlobalState();
    const [showNewSubmissionModal, setShowNewSubmissionModal] = useState(false);
    const [requestList, setRequestList] = useState([]);
    const [dateFrom, setDateFrom] = useState(getLastNDaysDate(5));
    const [dateTo, setDateTo] = useState(getCurrentDate());
    const [detail, setDetail] = useState(null);
    const [result, setResult] = useState(null)
    const [refreshUntil, setRefreshUntil] = useState(null);
    const intervalId = useRef(null);
    const [lastUpdateAt, setLastUpdateAt] = useState(null);


    const hideModel = !profile?.is_super;

    useEffect(() => {
        const fetch_ = async () => {
            const data = await getInvoiceList(dateFrom, dateTo);
            setRequestList(data);
        }
        fetch_();
    }, []);

    useEffect(()=> {
        setLastUpdateAt(new Date());
    }, [requestList]);

    useEffect(()=> {
        if (!refreshUntil) return;
        if (Date.now()> refreshUntil) return;  // stop refresh
        const fetch_ = async () => {
            const data = await getInvoiceList(dateFrom, dateTo);
            setRequestList(data);
        }

        fetch_();

        // continue refresh
        intervalId.current = setInterval(()=> {
            if (Date.now() > refreshUntil) {
                clearInterval(intervalId.current);
                intervalId.current = null;
                return;
            }

            // reload
            fetch_();
        }, 5000);

        return () => clearInterval(intervalId.current);
    }, [refreshUntil]);

    const fetchRequestList = async () => {
        try {
            const data = await getInvoiceList(dateFrom, dateTo);
            setRequestList(data);
        } catch (error) {
            console.error("Error fetching data. call setErrorMessage()", error);
            dispatch(setErrorMessage(error));
        } finally {
        }
    };

    const loadFullRequest = async (id) => {
        const result = await getFullRequest(id);
        setDetail(result);
    }

    const loadResult = async (id) => {
        const result = await getFullRequest(id);
        if (result?.generic) {
            result.generic['prompt'] = result?.prompt;
        }
        setResult(result);
    }


    const loadSteps = async (id) => {
        const result = await getSteps(id);
        setDetail(result);
    }
    const loadErrors = async (id) => {
        const result = await getErrors(id);
        setDetail(result);
    }

    const generateLinkFor = async (index, id) => {
        try {
            const links = await getTempFileLinks(id)
            setRequestList(prevList =>
                prevList.map((item, i) =>
                    i === index ? {...item, file_links: links} : item
                )
            )
        } catch (error) {
            dispatch(setErrorMessage(error));
        }
    }

    const onSubmitNewRequest = ()=> {
        setRefreshUntil( Date.now() + 60_000);
    }

    const newSubmissionModal= <MaxModal
        show={showNewSubmissionModal}
        useMaxFixed={true}
        handleClose = {()=>setShowNewSubmissionModal(false)}
        >
        <NewRequest
            callbackOnSubmit = {onSubmitNewRequest}
        />
    </MaxModal>


    const handleDelete = async (id) => {
        try {
            await deleteRequest(id);
            await fetchRequestList();
        } catch (error) {
            dispatch(setErrorMessage(error));
        }
    }

    const listDiv = (
        <div className={styles["data-container"]}>
            {requestList && (
                <div className={`${styles["item-row"]} ${styles["title"]}`}>
                    <div>uploaded at / by</div>
                    {/* <div>tenant</div>
                    <div>id</div> */}
                    <div>type</div>
                    <div>files</div>
                    <div>step</div>
                    <div>result</div>
                    <div>info</div>
                    <div>view files</div>
                    {/*<div>delete</div>*/}
                    <div>detail</div>
                    <div>..</div>
                </div>
            )}
            {requestList.map((item, index) => (
                <div className={styles["item-row"]}
                >
                    <div>
                        <div>{simplifyDateFormat2(item.received_at)}</div>
                        <div>{item?.user?.name}</div>
                        <div>{(item?.tenant_id || '').slice(-4)}</div>
                    </div>
                    {/*<div>{item.request_id}</div> */}
                    <div>{item.type}</div>
                    <div className={styles['files']}>
                        {item.files.map((f) => (
                            <div className={styles['link-line']}>
                                {f}
                            </div>
                        ))}
                    </div>
                    <div className={`${styles['status-'+item.step_status]}`}>{item.step_status}</div>
                    <div className={`${styles['process-status-'+item.process_status]}`}>{item.process_status}</div>
                    <div className={'mono-small'}>
                        <span>{item?.estimate_price? (profile.is_super? toDollarCost(item?.estimate_price): '***'):''}</span>
                    </div>
                    <div>
                        <div className={"fa-icon"}
                             onClick={() => generateLinkFor(index, item.request_id)}
                             title={"visualizar arquivos"}
                        >
                            <LuFileSearch/>
                        </div>
                        <div>
                            {(item?.file_links || []).map((f, index) => (
                                <div className={styles['link-line']}>
                                    {f?.url ? <a target="_blank" href={f.url}>{f.file_name}</a> : <>{f.file_name}</>}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={styles["action-buttons"]}>
                        {['processed', 'finished'].includes(item.step_status) && ['success'].includes(item.process_status) && <div className={"fa-icon -smaller -green"}
                             onClick={() => loadResult(item.request_id)}
                             title = "visualizar resultado da análise"
                        >
                            <BsClipboardCheck/>
                        </div>}
                        {profile.is_super && <div className={"fa-icon -smaller"}
                             onClick={() => loadFullRequest(item.request_id)}
                             title = "visualizar dados completos (p/ debug)"
                        >
                            <TbDatabaseSearch />
                        </div>}
                        {profile.is_super && !!item?.step_log_count && <div>
                            <div className={"fa-icon -smaller"}
                                 onClick={() => loadSteps(item.request_id)}
                                 title = "visualizar logs"
                            >
                                <RxActivityLog  />
                            </div>
                            {item?.step_log_count}
                        </div>}
                        {!!item?.error_log_count && <div>
                            <div
                                className={"fa-icon -smaller -redsh"}
                                onClick={() => loadErrors(item.request_id)}
                                title = "visualizar erros"
                            >
                            <FiAlertTriangle   />
                            </div>
                            {item?.error_log_count}
                        </div>}
                        {/*</div>}*/}
                        {/*    <button className={styles["view-logs"]} onClick={() => loadErrors(item.request_id)}>errors..*/}
                        {/*        ({item?.error_log_count})</button>}*/}
                    </div>
                    <div>
                        <div
                            className={"fa-icon -smaller"}
                            onClick={() => handleDelete(item.request_id)}
                            title = "delete"
                        >
                            <MdDelete   />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )

    const divDateRange = (<div className={styles['date-range-selection']}>
            <div>
                <label>De: </label>
                <input
                    type="date"
                    name="date_from"
                    value={dateFrom}
                    onChange={(e)=>setDateFrom(e.target.value)}
                    placeholder="YYYY-MM-DD"
                />
            </div>
            <div>
                <label>Até: </label>
                <input
                    type="date"
                    name="date_to"
                    value={dateTo}
                    onChange={(e)=>setDateTo(e.target.value)}
                    placeholder="YYYY-MM-DD"
                />
            </div>
        </div>
    )


    const divPanel = (
        <div className={styles['top-panel']}>
            <div className={styles['new-submit-panel']}>
                <button onClick={() => setShowNewSubmissionModal(true)}>
                    Submeter novos documentos
                </button>
            </div>
            <hr className={styles["separator"]}/>
            {divDateRange}
            <div className={styles["icons-panel"]}>
                <button type="button"
                        onClick={(e) => fetchRequestList()}
                        className={'button-alert  -with-icon'}>
                    Load
                    <IoReload/>
                </button>
                <div>{lastUpdateAt && lastUpdateAt.toLocaleString()}</div>
                {/*<button type="button"*/}
                {/*        onClick={(e) => fetchRequestListApiVersion()}*/}
                {/*>*/}
                {/*    Load using API version*/}
                {/*</button>*/}
            </div>
            {listDiv}
        </div>
    )

    const divDetail = !!detail && (<div className={styles['top-detail']}>
        <div className={styles['result-modal']}>
            <div className={styles['result-modal-panel']}>
                <div className={"fa-icon"}
                     onClick={()=>setDetail(null)}>
                    <FaXmark/>
                </div>
                {/*<button onClick={()=>setDetail(null)}>Close</button>*/}
            </div>
            <div className={styles['result-modal-content']}>
                <ReactJson src={detail} theme={theme === "light"? "rjv-default": "twilight"}/>
            </div>
        </div>
    </div>)

    const divResult = !!result  && (<div  className={styles['top-detail']}>
        <div className={styles['result-modal']}>
            <div className={styles['result-modal-panel']}>
                <div className={"fa-icon"}
                     onClick={()=>setResult(null)}>
                    <FaXmark/>
                </div>
            </div>
            {result.generic && <ResultCard data={result.generic}/>}
            {result.invoice && <ResultCardForInvoice data={result.invoice}/>}
        </div>
    </div>)

    return (
        <div className={styles['container']}>
            {divPanel}
            {divDetail}
            {divResult}
            {newSubmissionModal}
        </div>
    );
};

export default Request;
